import { AxiosRequestConfig } from 'axios';
import axiosInstance from 'src/utils/interceptor';

export const getCoupons = async (limit?: number) => {
  try {
    const url = process.env.REACT_APP_API_HOST_URL + '/coupon';
    let requestConfig: AxiosRequestConfig = {
      method: 'GET',
      url,
      params: {
        offset: 0,
        sort: '-_id',
        isActive: true,
        limit,
        "customData.isVisible": true
      },
    };
    requestConfig = JSON.parse(JSON.stringify(requestConfig));
    const response = await axiosInstance.get(url, requestConfig);
    return response.data;
  } catch (error) {
    throw error;
  }
};
